module.exports = __webpack_public_path__ + "img/maury_t1.9164d1f4.jpg";